import React from 'react'

import {
  Row,
  Col,
  BodyText,
  Link,
  Container,
  HeadingText,
} from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { PYPL_SAFETY_SECURITY, PRIVACY_FORM } from '../../constants/constants'
import PrivacyOptionTile from './PrivacyOptionTile'
import PrivacyOption from '../../modals/privacyhub/privacy-option'
import serverData from '../../utils/server-data'

const heading = (keys) => {
  if (keys) {
    return keys
      .split(',')
      .map((key) => (
        <PrivacyOption
          key={key}
          heading={<Message id={`privacyhub.${key}.heading`} />}
        />
      ))
  }
  return ''
}

const headingContent = (keys) => {
  if (keys) {
    return keys
      .split(',')
      .map((key) => (
        <PrivacyOption
          key={key}
          heading={<Message id={`privacyhub.${key}.heading`} />}
          content={<Message id={`privacyhub.${key}.content`} />}
        />
      ))
  }
  return ''
}
function PrivacyHubHome(props) {
  return (
    <div
      id="privacyHubHome"
      className="privacyHub_Home privacyHub_Home-content"
    >
      <div className="privacyHub_promise">
        <Container className="privacyHub_container">
          <Row>
            <Col md={12} lg={6} className="privacyHub_promiseContent">
              <div>
                <HeadingText
                  id="firstPromiseHeader"
                  size="hero"
                  className="privacyHub-heading"
                >
                  <Message id="privacyhub.privacypromise.title" />
                </HeadingText>
                <BodyText className="privacyHub-content">
                  <Message id="privacyhub.privacypromise.desc" />
                </BodyText>
              </div>
            </Col>
            <Col className="text-center">
              <img
                className="privacyHub_Image"
                alt="Our privacy first promise"
                src={`https://${serverData.cdnHostName}/privacyhub/promise.svg`}
              />
            </Col>
          </Row>
        </Container>
      </div>
      <div className="privacyHub_transparency">
        <Container className="privacyHub_container">
          <Row className="privacyHub_reverseColumn">
            <Col lg={5} className="text-center">
              <img
                alt=""
                className="privacyHub_transparencyImage"
                src={`https://${serverData.cdnHostName}/privacyhub/transparency.svg`}
              />
            </Col>
            <Col md={12} lg={6}>
              <HeadingText
                id="transparencyHeader"
                size="hero"
                className="privacyHub-heading2"
              >
                <Message id="privacyhub.transparencychoice.title" />
              </HeadingText>
              <BodyText as="p" className="privacyHub_paragraphMargin">
                <Message
                  id="privacyhub.transparencychoice.desc"
                  link={(innerMessage) => (
                    <Link
                      theme="v2"
                      name="transparencychoice"
                      id="privacyStatementLink"
                      href={props.keys && props.keys.privacyURL}
                      target="_blank"
                    >
                      {innerMessage}
                    </Link>
                  )}
                />
              </BodyText>
              <BodyText as="p" className="privacyHub_paragraphMargin">
                <Message id="privacyhub.transparencychoice.desc1" />
              </BodyText>
            </Col>
          </Row>
          <Row>
            <Col md={12} lg={6}>
              <PrivacyOptionTile
                badge={`https://${serverData.cdnHostName}/privacyhub/privacyChoice.svg`}
                name="privacyChoices"
                title={'privacyhub.privacychoices.title'}
                description={'privacyhub.privacychoices.desc'}
                linkText={'privacyhub.privacychoices.link'}
                onSectionClick={() =>
                  props.onSectionClick({
                    name: 'privacyChoices',
                    keys: props.keys,
                    content: headingContent,
                  })
                }
              />
            </Col>
            <Col>
              <PrivacyOptionTile
                badge={`https://${serverData.cdnHostName}/privacyhub/dataRights.svg`}
                name="privacyDataRights"
                title={'privacyhub.datarights.title'}
                description={'privacyhub.datarights.desc'}
                linkText={'privacyhub.datarights.link'}
                onSectionClick={() =>
                  props.onSectionClick({
                    name: 'privacyDataRights',
                    keys: props.keys,
                    content: headingContent,
                  })
                }
              />
            </Col>
          </Row>
          <Row>
            <Col md={12} lg={6}>
              <PrivacyOptionTile
                badge={`https://${serverData.cdnHostName}/privacyhub/communication.svg`}
                name="marketingPreferences"
                title={'privacyhub.marketingpreferences.title'}
                description={'privacyhub.marketingpreferences.desc'}
                linkText={'privacyhub.marketingpreferences.link'}
                onSectionClick={() =>
                  props.onSectionClick({
                    name: 'marketingPreferences',
                    keys: props.keys,
                    content: heading,
                  })
                }
              />
            </Col>
            <Col>
              <PrivacyOptionTile
                badge={`https://${serverData.cdnHostName}/privacyhub/securityOptions.svg`}
                name="securityOptions"
                title="privacyhub.securityoptions.title"
                description={'privacyhub.securityoptions.desc'}
                linkText={'privacyhub.securityoptions.link'}
                onSectionClick={() =>
                  props.onSectionClick({
                    name: 'securityOptions',
                    keys: props.keys,
                    content: heading,
                  })
                }
              />
            </Col>
          </Row>
        </Container>
      </div>
      <div className="privacyHub_promise">
        <Container className="privacyHub_container">
          <Row>
            <Col md={12} lg={6} className="privacyHub_promiseContent">
              {props.keys &&
                props.keys.promises &&
                props.keys.promises.split(',').map((key) => (
                  <div key={key}>
                    <HeadingText
                      id="peaceOfMindHeader"
                      size="hero"
                      className="privacyHub-heading2"
                    >
                      <Message id={`privacyhub.${key}.title`} />
                    </HeadingText>
                    <BodyText as="p" className="privacyHub_paragraphMargin">
                      <Message id={`privacyhub.${key}.desc`} />
                    </BodyText>
                    <BodyText as="p" className="privacyHub_paragraphMargin">
                      <Message id={`privacyhub.${key}.desc1`} />
                    </BodyText>
                    <BodyText as="p">
                      <Message
                        id={`privacyhub.${key}.desc2`}
                        link={(innerMessage) => (
                          <Link
                            theme="v2"
                            name="promise"
                            id="visitSecurityPageLink"
                            href={PYPL_SAFETY_SECURITY}
                            target="_blank"
                          >
                            {innerMessage}
                          </Link>
                        )}
                      />
                    </BodyText>
                  </div>
                ))}
            </Col>
            <Col className="text-center">
              <img
                alt="Peace of mind"
                className="privacyHub_Image"
                src={`https://${serverData.cdnHostName}/privacyhub/peaceOfMind.svg`}
              />
            </Col>
          </Row>
        </Container>
      </div>
      <div className="privacyHub_privacyQuestion">
        <Container>
          <Row>
            <Col className="privacyHub_privacyQuestionCenter text-center">
              <HeadingText
                id="privacyQuestionHeader"
                size="hero"
                className="privacyHub-heading2"
              >
                <Message id="privacyhub.privacyquestion.title" />
              </HeadingText>
              <BodyText className="privacyHub-content">
                <Message
                  id="privacyhub.privacyquestion.desc"
                  link={(innerMessage) => (
                    <Link
                      theme="v2"
                      name="privacyquestion"
                      id="privacyQuestionLink"
                      className="privacyHub-content privacyHub_questionLink"
                      href={PRIVACY_FORM}
                      target="_blank"
                    >
                      {innerMessage}
                    </Link>
                  )}
                />
              </BodyText>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  )
}
export default PrivacyHubHome
